import { useMemo, useRef } from 'react';

export function useClickHooks({ handleOnClick, data }: any) {
  const selectedRef = useRef(null);

  const eventsDict = useMemo(() => {
    const topNKey = data
      .map((item: any) => item.name)
      .filter((item: string) => item.toLocaleLowerCase() !== 'others');
    return {
      click: (params: any) => {
        let value = selectedRef.current === params?.name ? null : params?.name; 
        selectedRef.current = value;
        if (value === null) return handleOnClick?.({});
        if (value.toLocaleLowerCase() === 'others') {
          return handleOnClick?.({ exclude_languages: topNKey });
        } 
        handleOnClick?.({ languages: [value] });
      },
    };
  }, [data]);

  return {
    selected: selectedRef.current,
    eventsDict,
  };
}
